import React, { useContext, useEffect, useState } from "react";
import "./Navbar.css";
import logo from "../Assets/posher.png";
import cart_icon from "../Assets/cart_icon.png";
import { Link, useNavigate } from "react-router-dom";
import { ShopContext } from "../../Context/ShopContext";
import wishlist_icon from "../Assets/wishlist_icon.png";
import user_icon from "../Assets/user_icon.png";
import search_icon from "../Assets/search.png";
import { useUserStore } from "../../stores/useUserStores";
import { useProductStore } from "../../stores/useProductStores";
import { useCartStore } from "../../stores/useCartStores";
import { FiMenu, FiX } from "react-icons/fi";

const Navbar = () => {
  const [menu, setMenu] = useState("shop");
  const { getTotalCartItems } = useContext(ShopContext);
  const [searchTerm, setSearchTerm] = useState("");
  const [isSearchOpen, setSearchOpen] = useState(false);
  const [isCategoryDropdownOpen, setCategoryDropdownOpen] = useState(false);
  const [isUserDropdownOpen, setUserDropdownOpen] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isMobileView, setIsMobileView] = useState(false);
  const [currency, setCurrency] = useState("₦ Naira");
  const [loading, setLoading] = useState(true);

  const { cartItems, getCartProducts, wishlistItems } = useCartStore();
  const { user, logout, getUser } = useUserStore();
  const {
    getProductsByCategory,
    getNewCollections,
    searchProducts,
    searchResults,
  } = useProductStore();

  const [cartCount, setCartCount] = useState(0);
  const [wishlistCount, setWishlistCount] = useState(0);
  const navigate = useNavigate();

  const toggleSearch = () => setSearchOpen(!isSearchOpen);
  const toggleUserDropdown = () => setUserDropdownOpen(!isUserDropdownOpen);
  const toggleMobileMenu = () => setIsMobileMenuOpen(!isMobileMenuOpen);
  const closeMobileMenu = () => setIsMobileMenuOpen(false);

  const handleCurrencyChange = (e) => setCurrency(e.target.value);

  const handleSearch = (e) => {
    const value = e.target.value;
    setSearchTerm(value);
    searchProducts(value);
  };

  const handleCloseSearch = (e) => {
    if (e.target.className === "search-popup") setSearchOpen(false);
  };

  const getTotalCartItemsCount = () =>
    cartItems.reduce((total, item) => total + (item.quantity || 1), 0);

  useEffect(() => {
    const fetchUser = async () => {
      try {
        await getUser();
      } catch (error) {
        console.error("Failed to fetch user", error);
      } finally {
        setLoading(false);
      }
    };
    fetchUser();
  }, [getUser]);

  useEffect(() => {
    getCartProducts();
  }, []);

  useEffect(() => {
    setWishlistCount(wishlistItems.length || 0);
  }, [wishlistItems]);

  useEffect(() => {
    setCartCount(getTotalCartItemsCount());
    setWishlistCount(wishlistItems.length || 0);
  }, [cartItems, wishlistItems]);

  useEffect(() => {
    const handleResize = () => setIsMobileView(window.innerWidth <= 768);
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleLogout = async () => {
    await logout();
    navigate("/login");
  };

  const handleCategoryClick = async (category) => {
    await getProductsByCategory(category);
    navigate(`/${category}`);
    closeMobileMenu();
  };

  const handleNewCategory = async () => {
    await getNewCollections();
    navigate("/new");
    closeMobileMenu();
  };

  return (
    <div>
      {/* Top Bar */}
      <div className="top-bar">
        <div className="top-bar-left">
          <p>7 to 10 working days delivery + Fast international shipping</p>
        </div>
        <div className="top-bar-right">
          <div className="language-label">English</div>
          <select
            className="dropdown2"
            value={currency}
            onChange={handleCurrencyChange}
          >
            <option value="₦ Naira">₦</option>
            <option value="USD $">$</option>
          </select>
        </div>
      </div>

      {/* ✅ Navbar */}
      <nav className="navbar">
        {isMobileView ? (
          // ------------------ MOBILE VIEW ------------------
          <>
            {/* Left: Hamburger */}
            <div className="menu-toggle" onClick={toggleMobileMenu}>
              {isMobileMenuOpen ? <FiX size={22} /> : <FiMenu size={22} />}
            </div>

            {/* Center: Logo */}
           <img
             src={logo}
             alt="Logo"
            className="nav-logo"
            onClick={(e) => {
            e.stopPropagation();
            closeMobileMenu();
            navigate("/");
           }}
            />

            {/* Right: Icons */}
            <div className="nav-icons">
              <img
                src={search_icon}
                alt="Search"
                className="icon"
                onClick={toggleSearch}
              />
              <div
  className="user-profile-container"
  onClick={toggleUserDropdown}
>
  <img
    src={user_icon}
    alt="User"
    className="icon"
  />

  {isUserDropdownOpen && (
    <ul className="dropdowns-menu show">
      <li>
        <Link to="/account" className="dropdown-item">Profile</Link>
      </li>
      <li>
        <Link to="/orders" className="dropdown-item">Orders</Link>
      </li>
      <li>
        <span className="dropdown-item" onClick={logout}>Logout</span>
      </li>
    </ul>
       )}
     </div>
              <Link to="/Wishlist" onClick={closeMobileMenu}>
                <img src={wishlist_icon} alt="Wishlist" className="icon" />
              </Link>
              <Link to="/cart" onClick={closeMobileMenu}>
                <div className="cart-container">
                  <img src={cart_icon} alt="Cart" className="icon" />
                  <span className="nav-cart-count">{cartCount || 0}</span>
                </div>
              </Link>
            </div>

            {/* Slide-in Mobile Menu */}
            <ul className={`nav-menu ${isMobileMenuOpen ? "active" : "hidden"}`}>
              <li>
                <Link to="/" onClick={() => { setMenu("shop"); closeMobileMenu(); }}>
                  SHOP
                </Link>
              </li>
              <li>
                <Link to="/new" onClick={handleNewCategory}>
                  NEW ARRIVAL
                </Link>
              </li>
              <li>
            <Link to="/bridal">
             BRIDAL COLLECTION
            </Link>
            </li>
              <li>
                <span
                  className="nav-item"
                  onClick={() => setCategoryDropdownOpen(!isCategoryDropdownOpen)}
                >
                  CATEGORY
                </span>
                {isCategoryDropdownOpen && (
                  <ul className="dropdown-menu">
                    <li>
                      <Link
                        to="/co-ords"
                        onClick={() => handleCategoryClick("co-ords")}
                      >
                        Co-ords
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/dresses"
                        onClick={() => handleCategoryClick("dresses")}
                      >
                        Dresses
                      </Link>
                    </li>
                  </ul>
                )}
              </li>
              <li>
                <Link to="/consultation" onClick={closeMobileMenu}>
                  CONSULTATION
                </Link>
              </li>
            </ul>
          </>
        ) : (
          // ------------------ DESKTOP VIEW (unchanged) ------------------
          <>
            <Link to="/" className="nav-logo-link">
              <img src={logo} alt="logo" className="nav-logo" />
            </Link>

            <ul className="nav-menu">
              <li onClick={() => setMenu("shop")}>
                <Link to="/" className={menu === "shop" ? "active" : ""}>
                  SHOP
                </Link>
              </li>
              <li onClick={() => setMenu("new")}>
                <Link
                  to="/new"
                  className={menu === "new" ? "active" : ""}
                  onClick={handleNewCategory}
                >
                  NEW ARRIVAL
                </Link>
              </li>
             <li>
            <Link to="/bridal">
             BRIDAL COLLECTION
            </Link>
            </li>
              <li
                className="dropdown"
                onMouseEnter={() => setCategoryDropdownOpen(true)}
                onMouseLeave={() => setCategoryDropdownOpen(false)}
              >
                <span className="nav-item">CATEGORY</span>
                {isCategoryDropdownOpen && (
                  <ul className="dropdown-menu">
                    <li>
                      <Link
                        to="/co-ords"
                        className="dropdown-link"
                        onClick={() => handleCategoryClick("co-ords")}
                      >
                        Co-ords
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/dresses"
                        className="dropdown-link"
                        onClick={() => handleCategoryClick("dresses")}
                      >
                        Dresses
                      </Link>
                    </li>
                  </ul>
                )}
              </li>

              <li onClick={() => setMenu("consultation")}>
                <Link
                  to="/consultation"
                  className={menu === "consultation" ? "active" : ""}
                >
                  CONSULTATION
                </Link>
              </li>
            </ul>

            <div className="nav-icons">
              <img
                src={search_icon}
                alt="Search"
                className="icon"
                onClick={toggleSearch}
              />
              <div className="user-profile-container" onClick={toggleUserDropdown}>
                <img src={user_icon} alt="User" className="icon" />
                {isUserDropdownOpen && (
                  <ul className="dropdowns-menu">
                    {user ? (
                      <>
                        <li>
                          <Link to="/profile" className="dropdown-item">
                            Profile
                          </Link>
                        </li>
                        <li>
                          <Link to="/orders" className="dropdown-item">
                            Orders
                          </Link>
                        </li>
                        <li>
                          <Link to="/login" className="dropdown-item" onClick={handleLogout}>
                            Logout
                          </Link>
                        </li>
                      </>
                    ) : (
                      <li>
                        <Link to="/login" className="dropdown-item">
                          Login
                        </Link>
                        </li>
                    )}
                  </ul>
                )}
              </div>

              <Link to="/Wishlist" className="cart-container">
                <img src={wishlist_icon} alt="Wishlist" className="icon" />
              </Link>

              <Link to="/cart" className="cart-container">
                <img src={cart_icon} alt="Cart" className="icon" />
                <span className="nav-cart-count">{cartCount || 0}</span>
              </Link>
            </div>
          </>
        )}
      </nav>

      {/* Search Popup */}
      {isSearchOpen && (
        <div className="search-popup" onClick={handleCloseSearch}>
          <div className="search-container" onClick={(e) => e.stopPropagation()}>
            <input
              type="text"
              placeholder="Search products..."
              value={searchTerm}
              onChange={handleSearch}
              className="search-input"
            />

            <div className="search-results">
              {searchResults.length > 0 ? (
                searchResults.map((product) => (
                  <Link
                    key={product.id}
                    to={`/product/${product.slug || product.id}`}
                    onClick={() => setSearchOpen(false)}
                    className="search-item-link"
                  >
                    <div className="search-item">
                      <img
                        src={
                          product.images?.[0]?.url ||
                          product.image ||
                          "/placeholder.png"
                        }
                        alt={product.name}
                        className="search-item-img"
                      />
                      <div className="search-item-info">
                        <p className="search-item-name">{product.name}</p>
                        {product.price && (
                          <p className="search-item-price">
                            ₦{product.price.toLocaleString()}
                          </p>
                        )}
                        {Number(product.available_quantity ?? 0) <= 0 && (
                          <p className="search-item-stock">Out of stock</p>
                        )}
                      </div>
                    </div>
                  </Link>
                ))
              ) : (
                searchTerm && <p className="no-results">No products found</p>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Navbar;
